webpackJsonp([1],{

/***/ "+Bf1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5LIk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6XlR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Y4Lg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GxfC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jjan":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JwpD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vux-blazy/blazy.js
var blazy = __webpack_require__("iRq5");
var blazy_default = /*#__PURE__*/__webpack_require__.n(blazy);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/webp-support.js
var webp_support = __webpack_require__("p3QP");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var components_x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5a953a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-img/index.vue
var x_img_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vux-x-img",attrs:{"src":_vm.defaultSrc,"data-src":_vm.currentSrc}})}
var staticRenderFns = []
var esExports = { render: x_img_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_img = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-img/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("+Bf1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_img,
  src_components_x_img,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_img = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74122906","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/load-more/index.vue
var load_more_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-loadmore weui-loadmore",class:{'weui-loadmore_line':!_vm.showLoading, 'weui-loadmore_dot': !_vm.showLoading && !_vm.tip}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tip || !_vm.showLoading),expression:"tip || !showLoading"}],staticClass:"weui-loadmore__tips"},[_vm._v(_vm._s(_vm.tip))])])}
var load_more_staticRenderFns = []
var load_more_esExports = { render: load_more_render, staticRenderFns: load_more_staticRenderFns }
/* harmony default export */ var src_components_load_more = (load_more_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/load-more/index.vue
function load_more_injectStyle (ssrContext) {
  __webpack_require__("d4Xq")
}
var load_more_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var load_more___vue_template_functional__ = false
/* styles */
var load_more___vue_styles__ = load_more_injectStyle
/* scopeId */
var load_more___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var load_more___vue_module_identifier__ = null
var load_more_Component = load_more_normalizeComponent(
  components_load_more,
  src_components_load_more,
  load_more___vue_template_functional__,
  load_more___vue_styles__,
  load_more___vue_scopeId__,
  load_more___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_load_more = (load_more_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/index.vue





/* harmony default export */ var pages = ({

  components: { XImg: vux_src_components_x_img, LoadMore: vux_src_components_load_more },
  data: function data() {

    return {
      channelList: null, //轮播
      ac_area_id: -1, //选中的地区id
      areaList: null, //区域
      intangibleList: null,
      mapObj: null,
      mapMaxZoom: 18, //地图最大层级
      mapMinZoom: 5, //地图最小层级
      mapLat: 30.244132,
      mapLng: 120.147476,
      curMarkers: []
    };
  },

  filters: {
    setDis: function setDis(val) {
      var dis = (val / 1000).toFixed(1) + "km";
      return dis;
    }
  },

  computed: {},

  watch: {},

  methods: {
    getIntangibleList: function getIntangibleList(area_id) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/getRedMarkList",
        params: {

          lng: localStorage.getItem("lng"),
          lat: localStorage.getItem("lat"),
          area_id: area_id
        },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          that.intangibleList = data.data.data.intangibleList;
          that.setPoi(data.data.data.intangibleList);
          if (that.mapObj) {} else {
            that.setMap();
          }
          that.mapObj.clearMap();
          that.mapObj.add(that.curMarkers);
        }
      });
    },
    changeArea: function changeArea(id, i) {
      var that = this;
      if (id == this.ac_area_id) {
        return;
      } else {
        this.ac_area_id = id;
        this.getIntangibleList(id);
        this.$nextTick(function () {
          that.scrollMiddle(document.querySelectorAll("#areaList .area-item")[i], document.getElementById("areaList"));
          if (id != -1) {

            that.mapObj.setCenter([that.areaList[i].longitude_gcj, that.areaList[i].latitude_gcj]);
          } else {

            that.mapObj.setCenter([that.mapLng, that.mapLat]);
          }
        });
      }
    },
    getArea: function getArea() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/getZJAreaList",
        params: {},
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data);
          that.areaList = data.data.data.areaList;
        }
      });
    },
    setMap: function setMap() {
      var that = this;
      this.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({

          center: new AMap.LngLat(this.mapLng, this.mapLat),
          zoom: 9, //设置地图缩放级别
          rotation: 0
        }),
        resizeEnable: true,
        zooms: [this.mapMinZoom, this.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn"
      });
      var leLayer = new AMap.TileLayer({

        tileUrl: "https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]",
        zIndex: 2
      });
      leLayer.setMap(that.mapObj);
      this.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new AMap.ToolBar({
          position: "RB",

          liteStyle: true,
          offset: new AMap.Pixel(10, 100)
        }));
      });
    },
    setPoi: function setPoi(data) {
      var that = this;
      this.curMarkers = [];
      for (var i in data) {
        if (data[i].latitude && data[i].longitude) {
          console.log(data[i].longitude, data[i].latitude);
          var marker = new AMap.Marker({
            content: "<div class='poi'><div class='marker'></div><span class='poiName'>" + data[i].name + "</span></div>",
            position: new AMap.LngLat(data[i].longitude, data[i].latitude),
            offset: new AMap.Pixel(-12, -31),
            extData: {
              poiData: data[i]
            }
          });
          AMap.event.addListener(marker, "click", function (e) {
            var thisPosition = e.target.getPosition();
            var extData = e.target.getExtData().poiData;
            that.$router.push({
              path: "museum",
              query: { id: extData.id }
            });
          });

          this.curMarkers.push(marker);
        }
      }
    },
    scrollMiddle: function scrollMiddle(el, elParent) {
      var a = el.offsetLeft;
      var b = elParent.offsetWidth;
      var c = el.offsetWidth;
      elParent.scrollLeft = a - (b - c) / 2;
    }
  },

  created: function created() {},
  mounted: function mounted() {
    this.getIntangibleList(this.ac_area_id);
    this.getArea();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/index.vue





/* harmony default export */ var selectortype_script_index_0_src_pages = ({

  components: { XImg: vux_src_components_x_img, LoadMore: vux_src_components_load_more },
  data: function data() {

    return {
      channelList: null, //轮播
      ac_area_id: -1, //选中的地区id
      areaList: null, //区域
      intangibleList: null,
      mapObj: null,
      mapMaxZoom: 18, //地图最大层级
      mapMinZoom: 5, //地图最小层级
      mapLat: 30.244132,
      mapLng: 120.147476,
      curMarkers: []
    };
  },

  filters: {
    setDis: function setDis(val) {
      var dis = (val / 1000).toFixed(1) + "km";
      return dis;
    }
  },

  computed: {},

  watch: {},

  methods: {
    getIntangibleList: function getIntangibleList(area_id) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/getRedMarkList",
        params: {

          lng: localStorage.getItem("lng"),
          lat: localStorage.getItem("lat"),
          area_id: area_id
        },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          that.intangibleList = data.data.data.intangibleList;
          that.setPoi(data.data.data.intangibleList);
          if (that.mapObj) {} else {
            that.setMap();
          }
          that.mapObj.clearMap();
          that.mapObj.add(that.curMarkers);
        }
      });
    },
    changeArea: function changeArea(id, i) {
      var that = this;
      if (id == this.ac_area_id) {
        return;
      } else {
        this.ac_area_id = id;
        this.getIntangibleList(id);
        this.$nextTick(function () {
          that.scrollMiddle(document.querySelectorAll("#areaList .area-item")[i], document.getElementById("areaList"));
          if (id != -1) {

            that.mapObj.setCenter([that.areaList[i].longitude_gcj, that.areaList[i].latitude_gcj]);
          } else {

            that.mapObj.setCenter([that.mapLng, that.mapLat]);
          }
        });
      }
    },
    getArea: function getArea() {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/getZJAreaList",
        params: {},
        isShowLoading: false,
        success: function success(data) {
          console.log(data.data);
          that.areaList = data.data.data.areaList;
        }
      });
    },
    setMap: function setMap() {
      var that = this;
      this.mapObj = new AMap.Map("container", {
        view: new AMap.View2D({

          center: new AMap.LngLat(this.mapLng, this.mapLat),
          zoom: 9, //设置地图缩放级别
          rotation: 0
        }),
        resizeEnable: true,
        zooms: [this.mapMinZoom, this.mapMaxZoom],
        features: ["bg", "road", "building"],
        lang: "zh_cn"
      });
      var leLayer = new AMap.TileLayer({

        tileUrl: "https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]",
        zIndex: 2
      });
      leLayer.setMap(that.mapObj);
      this.mapObj.plugin(["AMap.ToolBar"], function () {
        that.mapObj.addControl(new AMap.ToolBar({
          position: "RB",

          liteStyle: true,
          offset: new AMap.Pixel(10, 100)
        }));
      });
    },
    setPoi: function setPoi(data) {
      var that = this;
      this.curMarkers = [];
      for (var i in data) {
        if (data[i].latitude && data[i].longitude) {
          console.log(data[i].longitude, data[i].latitude);
          var marker = new AMap.Marker({
            content: "<div class='poi'><div class='marker'></div><span class='poiName'>" + data[i].name + "</span></div>",
            position: new AMap.LngLat(data[i].longitude, data[i].latitude),
            offset: new AMap.Pixel(-12, -31),
            extData: {
              poiData: data[i]
            }
          });
          AMap.event.addListener(marker, "click", function (e) {
            var thisPosition = e.target.getPosition();
            var extData = e.target.getExtData().poiData;
            that.$router.push({
              path: "museum",
              query: { id: extData.id }
            });
          });

          this.curMarkers.push(marker);
        }
      }
    },
    scrollMiddle: function scrollMiddle(el, elParent) {
      var a = el.offsetLeft;
      var b = elParent.offsetWidth;
      var c = el.offsetWidth;
      elParent.scrollLeft = a - (b - c) / 2;
    }
  },

  created: function created() {},
  mounted: function mounted() {
    this.getIntangibleList(this.ac_area_id);
    this.getArea();
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2bcd0c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
var pages_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{attrs:{"id":"container"}}),_vm._v(" "),_c('ul',{staticClass:"area-list",attrs:{"id":"areaList"}},_vm._l((_vm.areaList),function(item,index){return _c('li',{key:index,class:['area-item', _vm.ac_area_id == item.id ? 'on' : ''],on:{"click":function($event){return _vm.changeArea(item.id, index)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0),_vm._v(" "),(_vm.intangibleList != null && _vm.intangibleList.length > 0)?_c('div',{staticClass:"intangible-list",attrs:{"id":"intangibleList"}},[_vm._l((_vm.intangibleList),function(item,index){return _c('router-link',{key:index,staticClass:"intangible-item",attrs:{"to":{ path: 'museum', query: { id: item.id } }}},[_c('x-img',{staticClass:"intangible-cover",attrs:{"offset":20,"container":"#intangibleList","src":item.thumb_img == null || item.thumb_img == '' ? '' : item.thumb_img}}),_vm._v(" "),_c('div',{staticClass:"intangible-content"},[_c('div',{staticClass:"intangible-title"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"intangible-intro ellipsis-2"},[_vm._v(_vm._s(item.intro))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.distance),expression:"item.distance"}],staticClass:"intangible-dis"},[_c('span',[_vm._v(_vm._s(_vm._f("setDis")(item.distance)))])])])],1)}),_vm._v(" "),_c('load-more',{attrs:{"show-loading":false,"tip":"加载完毕","background-color":"#fbf9fe"}})],2):_c('div',{},[_c('load-more',{attrs:{"show-loading":false,"tip":"暂无数据","background-color":"#fbf9fe"}})],1)])}
var pages_staticRenderFns = []
var pages_esExports = { render: pages_render, staticRenderFns: pages_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages = (pages_esExports);
// CONCATENATED MODULE: ./src/pages/index.vue
function pages_injectStyle (ssrContext) {
  __webpack_require__("WBQF")
  __webpack_require__("Jjan")
}
var pages_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pages___vue_template_functional__ = false
/* styles */
var pages___vue_styles__ = pages_injectStyle
/* scopeId */
var pages___vue_scopeId__ = "data-v-d2bcd0c6"
/* moduleIdentifier (server only) */
var pages___vue_module_identifier__ = null
var pages_Component = pages_normalizeComponent(
  selectortype_script_index_0_src_pages,
  selectortype_template_index_0_src_pages,
  pages___vue_template_functional__,
  pages___vue_styles__,
  pages___vue_scopeId__,
  pages___vue_module_identifier__
)

/* harmony default export */ var src_pages = (pages_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe8f518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("gWrV")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd6837a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/museum.vue







/* harmony default export */ var museum = ({

  components: { Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item, XImg: vux_src_components_x_img, LoadMore: vux_src_components_load_more },
  data: function data() {

    return {
      audioSrc: null, //音频地址
      audioPlaying: false, //音频播放状态
      id: this.$route.query.id,
      museum: null,
      ac_poiIndex: -1, //选中的pois 默认-1
      isOver3Line: false, //intro是否超过三行
      isOpenLines: false
    };
  },

  filters: {
    setDis: function setDis(val) {
      var dis = "距您" + (val / 1000).toFixed(1) + "km";
      return dis;
    }
  },

  computed: {},

  watch: {},

  methods: {
    getIntangibleDetail: function getIntangibleDetail(id) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/getIntangibleDetail",
        params: {

          lng: localStorage.getItem("lng"),
          lat: localStorage.getItem("lat"),
          id: id
        },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          that.museum = data.data.data;
          document.title = data.data.data.detail.name;
          that.$nextTick(function () {

            var height = document.getElementById("intro").clientHeight;
            console.log(height);

            var lineHeight = document.getElementById("intro").style.lineHeight.split("rem")[0] * document.documentElement.style.fontSize.split("px")[0];
            console.log(lineHeight);
            if (height / lineHeight > 3) {
              console.log("超出3行");
              that.isOver3Line = true;
            } else {
              console.log("没超过3行");
              that.isOver3Line = false;
            }
          });
        }
      });
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, localStorage.getItem("lat"), localStorage.getItem("lng"), lat, lng);
    },
    playAudio: function playAudio(i) {
      var that = this;
      var audio = document.getElementById("myAudio");
      if (this.museum.pointsList[i].audio != null && this.commonFun.trim(this.museum.pointsList[i].audio) != "") {
        if (i == this.ac_poiIndex) {
          if (audio.paused) {
            that.audioPlaying = true;
            audio.play();
          } else {
            that.audioPlaying = false;
            audio.pause();
          }
        } else {
          this.ac_poiIndex = i;
          var idx = this.museum.pointsList[i].audio.lastIndexOf(".");
          this.audioSrc = this.museum.pointsList[i].audio.substring(0, idx + 1) + "mp3";

          audio.load();
          audio.addEventListener("canplay", function () {
            audio.play();
          });
          this.audioPlaying = true;

          audio.addEventListener("ended", function () {
            that.ac_poiIndex = -1;
            that.audioPlaying = false;
          }, false);
        }
      } else {
        that.$vux.toast.text("暂无音频", "bottom");
      }
    },
    jumpToPoi: function jumpToPoi(id) {
      this.$router.push({
        path: "poi",
        query: {
          id: id
        }
      });
    }
  },

  created: function created() {
    this.getIntangibleDetail(this.id);
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/museum.vue







/* harmony default export */ var pages_museum = ({

  components: { Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item, XImg: vux_src_components_x_img, LoadMore: vux_src_components_load_more },
  data: function data() {

    return {
      audioSrc: null, //音频地址
      audioPlaying: false, //音频播放状态
      id: this.$route.query.id,
      museum: null,
      ac_poiIndex: -1, //选中的pois 默认-1
      isOver3Line: false, //intro是否超过三行
      isOpenLines: false
    };
  },

  filters: {
    setDis: function setDis(val) {
      var dis = "距您" + (val / 1000).toFixed(1) + "km";
      return dis;
    }
  },

  computed: {},

  watch: {},

  methods: {
    getIntangibleDetail: function getIntangibleDetail(id) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/getIntangibleDetail",
        params: {

          lng: localStorage.getItem("lng"),
          lat: localStorage.getItem("lat"),
          id: id
        },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          that.museum = data.data.data;
          document.title = data.data.data.detail.name;
          that.$nextTick(function () {

            var height = document.getElementById("intro").clientHeight;
            console.log(height);

            var lineHeight = document.getElementById("intro").style.lineHeight.split("rem")[0] * document.documentElement.style.fontSize.split("px")[0];
            console.log(lineHeight);
            if (height / lineHeight > 3) {
              console.log("超出3行");
              that.isOver3Line = true;
            } else {
              console.log("没超过3行");
              that.isOver3Line = false;
            }
          });
        }
      });
    },
    nav: function nav(name, lat, lng) {
      this.commonFun.openLocation(name, localStorage.getItem("lat"), localStorage.getItem("lng"), lat, lng);
    },
    playAudio: function playAudio(i) {
      var that = this;
      var audio = document.getElementById("myAudio");
      if (this.museum.pointsList[i].audio != null && this.commonFun.trim(this.museum.pointsList[i].audio) != "") {
        if (i == this.ac_poiIndex) {
          if (audio.paused) {
            that.audioPlaying = true;
            audio.play();
          } else {
            that.audioPlaying = false;
            audio.pause();
          }
        } else {
          this.ac_poiIndex = i;
          var idx = this.museum.pointsList[i].audio.lastIndexOf(".");
          this.audioSrc = this.museum.pointsList[i].audio.substring(0, idx + 1) + "mp3";

          audio.load();
          audio.addEventListener("canplay", function () {
            audio.play();
          });
          this.audioPlaying = true;

          audio.addEventListener("ended", function () {
            that.ac_poiIndex = -1;
            that.audioPlaying = false;
          }, false);
        }
      } else {
        that.$vux.toast.text("暂无音频", "bottom");
      }
    },
    jumpToPoi: function jumpToPoi(id) {
      this.$router.push({
        path: "poi",
        query: {
          id: id
        }
      });
    }
  },

  created: function created() {
    this.getIntangibleDetail(this.id);
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b3162c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/museum.vue
var museum_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.museum)?_c('div',{staticClass:"page"},[_c('audio',{attrs:{"src":_vm.audioSrc,"id":"myAudio"}}),_vm._v(" "),_c('div',{staticClass:"banner"},[_c('swiper',{staticClass:"channel-list",attrs:{"aspect-ratio":360 / 750,"loop":true,"auto":true,"show-dots":false}},_vm._l((_vm.museum.imgList),function(item,index){return _c('swiper-item',{key:index},[_c('img',{staticClass:"channel-bg",attrs:{"src":_vm.GLOBAL.DOMAIN_URL + item.midImg,"alt":""}})])}),1),_vm._v(" "),_c('div',{staticClass:"banner-bar"},[(_vm.museum.detail.distance)?_c('span',{staticClass:"distance"},[_vm._v(_vm._s(_vm._f("setDis")(_vm.museum.detail.distance)))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"nav-to",on:{"click":function($event){return _vm.nav(
            _vm.museum.detail.name,
            _vm.museum.detail.latitude,
            _vm.museum.detail.longitude
          )}}},[_vm._v("到这去")])])],1),_vm._v(" "),_c('div',{staticClass:"mm-intro-box"},[_c('p',{class:['mm-intro', _vm.isOver3Line && !_vm.isOpenLines ? 'ellipsis-3' : ''],staticStyle:{"line-height":"0.48rem"},attrs:{"id":"intro"}},[_vm._v("\n      "+_vm._s(_vm.museum.detail.intro)+"\n    ")]),_vm._v(" "),(_vm.isOver3Line)?_c('span',{staticClass:"updown",on:{"click":function($event){_vm.isOpenLines = !_vm.isOpenLines}}},[_vm._v("\n      "+_vm._s(_vm.isOpenLines ? "收起" : "展开")+"\n      "),_c('i',{class:['icon-updown', _vm.isOpenLines ? 'up' : '']})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mm-content"},[(
        _vm.museum.detail.address != null &&
          _vm.commonFun.trim(_vm.museum.detail.address) != ''
      )?_c('div',{staticClass:"mm-content-section"},[_c('i',{staticClass:"section-icon icon-nav"}),_vm._v(" "),_c('span',{staticClass:"section-content ellipsis-2"},[_vm._v(_vm._s(_vm.museum.detail.address))])]):_vm._e(),_vm._v(" "),(
        _vm.museum.detail.open_time != null &&
          _vm.commonFun.trim(_vm.museum.detail.open_time) != ''
      )?_c('div',{staticClass:"mm-content-section"},[_c('i',{staticClass:"section-icon icon-time"}),_vm._v(" "),_c('span',{staticClass:"section-content ellipsis-2"},[_vm._v(_vm._s(_vm.museum.detail.open_time))])]):_vm._e(),_vm._v(" "),(
        _vm.museum.detail.phone != null &&
          _vm.commonFun.trim(_vm.museum.detail.phone) != ''
      )?_c('a',{staticClass:"mm-content-section",attrs:{"href":'tel:' + _vm.museum.detail.phone}},[_c('i',{staticClass:"section-icon icon-phone"}),_vm._v(" "),_c('span',{staticClass:"section-content ellipsis-2"},[_vm._v(_vm._s(_vm.museum.detail.phone))])]):_vm._e()])]):_vm._e()}
var museum_staticRenderFns = []
var museum_esExports = { render: museum_render, staticRenderFns: museum_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_museum = (museum_esExports);
// CONCATENATED MODULE: ./src/pages/museum.vue
function museum_injectStyle (ssrContext) {
  __webpack_require__("QoHd")
}
var museum_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var museum___vue_template_functional__ = false
/* styles */
var museum___vue_styles__ = museum_injectStyle
/* scopeId */
var museum___vue_scopeId__ = "data-v-0b3162c2"
/* moduleIdentifier (server only) */
var museum___vue_module_identifier__ = null
var museum_Component = museum_normalizeComponent(
  pages_museum,
  selectortype_template_index_0_src_pages_museum,
  museum___vue_template_functional__,
  museum___vue_styles__,
  museum___vue_scopeId__,
  museum___vue_module_identifier__
)

/* harmony default export */ var src_pages_museum = (museum_Component.exports);

// EXTERNAL MODULE: ./node_modules/video.js/dist/video-js.css
var video_js = __webpack_require__("g3Gj");
var video_js_default = /*#__PURE__*/__webpack_require__.n(video_js);

// EXTERNAL MODULE: ./node_modules/vue-video-player/src/custom-theme.css
var custom_theme = __webpack_require__("5LIk");
var custom_theme_default = /*#__PURE__*/__webpack_require__.n(custom_theme);

// EXTERNAL MODULE: ./node_modules/vue-video-player/dist/vue-video-player.js
var vue_video_player = __webpack_require__("iqGf");
var vue_video_player_default = /*#__PURE__*/__webpack_require__.n(vue_video_player);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myVideo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var myVideo = ({
  props: {
    width: {
      type: Number,
      default: document.documentElement.clientWidth
    },
    height: {
      type: Number
    },
    sources: {
      type: String
    },
    poster: {
      type: String
    }
  },
  data: function data() {
    return {
      playerOptions: {
        //        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        // aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",
          src: this.sources //你的视频地址（必填）
        }],
        poster: this.poster, //你的封面地址
        width: this.width,
        height: this.height,
        notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //        controlBar: {
        //          timeDivider: true,
        //          durationDisplay: true,
        //          remainingTimeDisplay: false,
        //          fullscreenToggle: true  //全屏按钮
        //        }
      }
    };
  },

  components: {
    videoPlayer: vue_video_player["videoPlayer"]
  },
  methods: {
    onPlayerPlay: function onPlayerPlay(player) {
      console.log("播放器 play");
    },
    onPlayerPause: function onPlayerPause(player) {
      console.log("播放器 pause");
    },
    onPlayerEnded: function onPlayerEnded(player) {
      console.log("播放器 end");
      //   触发父组件监听的事件  关闭此组件
      this.$emit("videoEnd");
    }
  },
  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myVideo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_myVideo = ({
  props: {
    width: {
      type: Number,
      default: document.documentElement.clientWidth
    },
    height: {
      type: Number
    },
    sources: {
      type: String
    },
    poster: {
      type: String
    }
  },
  data: function data() {
    return {
      playerOptions: {
        //        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        // aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",
          src: this.sources //你的视频地址（必填）
        }],
        poster: this.poster, //你的封面地址
        width: this.width,
        height: this.height,
        notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //        controlBar: {
        //          timeDivider: true,
        //          durationDisplay: true,
        //          remainingTimeDisplay: false,
        //          fullscreenToggle: true  //全屏按钮
        //        }
      }
    };
  },

  components: {
    videoPlayer: vue_video_player["videoPlayer"]
  },
  methods: {
    onPlayerPlay: function onPlayerPlay(player) {
      console.log("播放器 play");
    },
    onPlayerPause: function onPlayerPause(player) {
      console.log("播放器 pause");
    },
    onPlayerEnded: function onPlayerEnded(player) {
      console.log("播放器 end");
      //   触发父组件监听的事件  关闭此组件
      this.$emit("videoEnd");
    }
  },
  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2cd7df0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myVideo.vue
var myVideo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",attrs:{"playsinline":true,"options":_vm.playerOptions},on:{"play":function($event){return _vm.onPlayerPlay($event)},"pause":function($event){return _vm.onPlayerPause($event)},"ended":function($event){return _vm.onPlayerEnded($event)}}})],1)}
var myVideo_staticRenderFns = []
var myVideo_esExports = { render: myVideo_render, staticRenderFns: myVideo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_myVideo = (myVideo_esExports);
// CONCATENATED MODULE: ./src/components/myVideo.vue
function myVideo_injectStyle (ssrContext) {
  __webpack_require__("GxfC")
}
var myVideo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myVideo___vue_template_functional__ = false
/* styles */
var myVideo___vue_styles__ = myVideo_injectStyle
/* scopeId */
var myVideo___vue_scopeId__ = "data-v-a2cd7df0"
/* moduleIdentifier (server only) */
var myVideo___vue_module_identifier__ = null
var myVideo_Component = myVideo_normalizeComponent(
  components_myVideo,
  selectortype_template_index_0_src_components_myVideo,
  myVideo___vue_template_functional__,
  myVideo___vue_styles__,
  myVideo___vue_scopeId__,
  myVideo___vue_module_identifier__
)

/* harmony default export */ var src_components_myVideo = (myVideo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myAudio.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var myAudio = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    audioSrc: {
      type: String
    },
    height: {
      type: String
    }
  },
  data: function data() {
    //这里存放数据
    return {
      // 音频播放
      duration: "00:00", //音频总时长
      audioCurTime: "00:00", //音频当前时间
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0 //进度点的left值
      // 音频播放
    };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 点击进度条跳到指定点播放
    // PS：此处不要用click，否则下面的拖动进度点事件有可能在此处触发，此时e.offsetX的值非常小，会导致进度条弹回开始处
    progressBarBg: function progressBarBg(e) {
      var audio = document.getElementById("dtAudio");
      if (!audio.paused || audio.currentTime != 0) {
        // let pgsWidth = $(".progress-bar-bg").width();
        var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        var rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },

    // 鼠标拖动进度点时可以调节进度
    // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
    // 鼠标按下时
    progressDot: function progressDot(e) {
      var that = this;
      var audio = document.getElementById("dtAudio");
      var dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        var oriLeft = dot.offsetLeft;
        var mouseX = e.clientX;
        var maxLeft = oriLeft; // 向左最大可拖动距离
        var maxRight = document.getElementById("progressBarBg").offsetWidth - oriLeft; // 向右最大可拖动距离

        // 禁止默认的选中事件（避免鼠标拖拽进度点的时候选中文字）
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        // 禁止事件冒泡
        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        // 开始拖动
        document.onmousemove = function (e) {
          var length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].width;
          var rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        // 拖动结束
        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },

    // 音频播放停止事件
    audioPlay: function audioPlay() {
      var that = this;
      var audio = document.getElementById("dtAudio");
      // 监听音频播放时间并更新进度条
      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      // 监听播放完成事件
      audio.addEventListener("ended", function () {
        that.audioEnded();
      }, false);

      // 改变播放/暂停图片
      if (audio.paused) {
        // 开始播放当前点击的音频
        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },

    // 更新进度条与当前播放时间 audio - audio对象
    updateProgress: function updateProgress(audio) {
      var value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
      this.audioCurTime = this.commonFun.transTime(audio.currentTime);
      this.duration = this.commonFun.transTime(audio.duration);
    },

    //  播放完成时把进度调回开始的位置
    audioEnded: function audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
      this.audioCurTime = "00:00";
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    var that = this;
    var audio = document.getElementById("dtAudio");
    audio.load();
    //监听音频是否可以播放 获取时长
    audio.addEventListener("canplay", function () {
      that.duration = that.commonFun.transTime(audio.duration);
    });
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myAudio.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

/* harmony default export */ var components_myAudio = ({
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    audioSrc: {
      type: String
    },
    height: {
      type: String
    }
  },
  data: function data() {
    //这里存放数据
    return {
      // 音频播放
      duration: "00:00", //音频总时长
      audioCurTime: "00:00", //音频当前时间
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0 //进度点的left值
      // 音频播放
    };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 点击进度条跳到指定点播放
    // PS：此处不要用click，否则下面的拖动进度点事件有可能在此处触发，此时e.offsetX的值非常小，会导致进度条弹回开始处
    progressBarBg: function progressBarBg(e) {
      var audio = document.getElementById("dtAudio");
      if (!audio.paused || audio.currentTime != 0) {
        // let pgsWidth = $(".progress-bar-bg").width();
        var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        var rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },

    // 鼠标拖动进度点时可以调节进度
    // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
    // 鼠标按下时
    progressDot: function progressDot(e) {
      var that = this;
      var audio = document.getElementById("dtAudio");
      var dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        var oriLeft = dot.offsetLeft;
        var mouseX = e.clientX;
        var maxLeft = oriLeft; // 向左最大可拖动距离
        var maxRight = document.getElementById("progressBarBg").offsetWidth - oriLeft; // 向右最大可拖动距离

        // 禁止默认的选中事件（避免鼠标拖拽进度点的时候选中文字）
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        // 禁止事件冒泡
        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        // 开始拖动
        document.onmousemove = function (e) {
          var length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          var pgsWidth = document.getElementsByClassName("progress-bar-bg")[0].width;
          var rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        // 拖动结束
        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },

    // 音频播放停止事件
    audioPlay: function audioPlay() {
      var that = this;
      var audio = document.getElementById("dtAudio");
      // 监听音频播放时间并更新进度条
      audio.addEventListener("timeupdate", function () {
        that.updateProgress(audio);
      }, false);

      // 监听播放完成事件
      audio.addEventListener("ended", function () {
        that.audioEnded();
      }, false);

      // 改变播放/暂停图片
      if (audio.paused) {
        // 开始播放当前点击的音频
        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },

    // 更新进度条与当前播放时间 audio - audio对象
    updateProgress: function updateProgress(audio) {
      var value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
      this.audioCurTime = this.commonFun.transTime(audio.currentTime);
      this.duration = this.commonFun.transTime(audio.duration);
    },

    //  播放完成时把进度调回开始的位置
    audioEnded: function audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
      this.audioCurTime = "00:00";
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created: function created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted: function mounted() {
    var that = this;
    var audio = document.getElementById("dtAudio");
    audio.load();
    //监听音频是否可以播放 获取时长
    audio.addEventListener("canplay", function () {
      that.duration = that.commonFun.transTime(audio.duration);
    });
  },
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f58890","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myAudio.vue
var myAudio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-box",style:({'height':_vm.height})},[_c('audio',{attrs:{"src":_vm.audioSrc,"id":"dtAudio"}}),_vm._v(" "),_c('div',{class:['audio-left',_vm.playing?'play':'pause'],attrs:{"id":"audioPlayer"},on:{"click":_vm.audioPlay}}),_vm._v(" "),_c('div',{staticClass:"audio-right"},[_c('div',{staticClass:"progress-bar-bg",attrs:{"id":"progressBarBg"},on:{"mousedown":_vm.progressBarBg}},[_c('span',{style:('left:'+_vm.dotLeft+'%'),attrs:{"id":"progressDot"},on:{"mousedown":_vm.progressDot}}),_vm._v(" "),_c('div',{staticClass:"progress-bar",style:('width:'+_vm.barWidth+'%'),attrs:{"id":"progressBar"}})]),_vm._v(" "),_c('div',{staticClass:"audio-time"},[_c('span',{staticClass:"audio-length-current",attrs:{"id":"audioCurTime"}},[_vm._v(_vm._s(_vm.audioCurTime))]),_vm._v("/\n      "),_c('span',{staticClass:"audio-length-total"},[_vm._v(_vm._s(_vm.duration))])])])])}
var myAudio_staticRenderFns = []
var myAudio_esExports = { render: myAudio_render, staticRenderFns: myAudio_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_myAudio = (myAudio_esExports);
// CONCATENATED MODULE: ./src/components/myAudio.vue
function myAudio_injectStyle (ssrContext) {
  __webpack_require__("JwpD")
}
var myAudio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myAudio___vue_template_functional__ = false
/* styles */
var myAudio___vue_styles__ = myAudio_injectStyle
/* scopeId */
var myAudio___vue_scopeId__ = "data-v-05f58890"
/* moduleIdentifier (server only) */
var myAudio___vue_module_identifier__ = null
var myAudio_Component = myAudio_normalizeComponent(
  components_myAudio,
  selectortype_template_index_0_src_components_myAudio,
  myAudio___vue_template_functional__,
  myAudio___vue_styles__,
  myAudio___vue_scopeId__,
  myAudio___vue_module_identifier__
)

/* harmony default export */ var src_components_myAudio = (myAudio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/poi.vue







/* harmony default export */ var poi = ({

  components: { Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item, myVideo: src_components_myVideo, myAudio: src_components_myAudio },
  data: function data() {

    return {
      id: this.$route.query.id,
      poi: null,
      videoHeight: 0, //视频高度
      isShowVideo: false,
      audioSrc: null
    };
  },


  computed: {},

  watch: {},

  methods: {
    getIntangiblePointsDetail: function getIntangiblePointsDetail(id) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/getIntangiblePointsDetail",
        params: {
          id: id
        },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          that.poi = data.data.data;
          document.title = data.data.data.pointsDetail.name;
          if (data.data.data.pointsDetail.audio) {
            var idx = data.data.data.pointsDetail.audio.lastIndexOf(".");
            that.audioSrc = data.data.data.pointsDetail.audio.substring(0, idx + 1) + "mp3";
          }

          that.$nextTick(function () {
            that.videoHeight = document.getElementById("banner").offsetHeight;
          });
        }
      });
    },
    playVideo: function playVideo() {
      var that = this;
      this.isShowVideo = true;
    },
    myVideoEnded: function myVideoEnded() {
      this.isShowVideo = false;
    }
  },

  created: function created() {
    this.getIntangiblePointsDetail(this.id);
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/poi.vue







/* harmony default export */ var pages_poi = ({

  components: { Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item, myVideo: src_components_myVideo, myAudio: src_components_myAudio },
  data: function data() {

    return {
      id: this.$route.query.id,
      poi: null,
      videoHeight: 0, //视频高度
      isShowVideo: false,
      audioSrc: null
    };
  },


  computed: {},

  watch: {},

  methods: {
    getIntangiblePointsDetail: function getIntangiblePointsDetail(id) {
      var that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/getIntangiblePointsDetail",
        params: {
          id: id
        },
        isShowLoading: true,
        success: function success(data) {
          console.log(data.data);
          that.poi = data.data.data;
          document.title = data.data.data.pointsDetail.name;
          if (data.data.data.pointsDetail.audio) {
            var idx = data.data.data.pointsDetail.audio.lastIndexOf(".");
            that.audioSrc = data.data.data.pointsDetail.audio.substring(0, idx + 1) + "mp3";
          }

          that.$nextTick(function () {
            that.videoHeight = document.getElementById("banner").offsetHeight;
          });
        }
      });
    },
    playVideo: function playVideo() {
      var that = this;
      this.isShowVideo = true;
    },
    myVideoEnded: function myVideoEnded() {
      this.isShowVideo = false;
    }
  },

  created: function created() {
    this.getIntangiblePointsDetail(this.id);
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  //生命周期 - 创建之前
  beforeMount: function beforeMount() {},
  //生命周期 - 挂载之前
  beforeUpdate: function beforeUpdate() {},
  //生命周期 - 更新之前
  updated: function updated() {},
  //生命周期 - 更新之后
  beforeDestroy: function beforeDestroy() {},
  //生命周期 - 销毁之前
  destroyed: function destroyed() {},
  //生命周期 - 销毁完成
  activated: function activated() {} //如果页面有keep-alive缓存功能，这个函数会触发

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06aad74c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/poi.vue
var poi_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.poi)?_c('div',{staticClass:"page"},[_c('div',{staticClass:"banner",attrs:{"id":"banner"}},[(_vm.poi.imgList != null && _vm.poi.imgList.length > 0)?_c('div',[(_vm.isShowVideo)?_c('myVideo',{ref:"myVideo",staticClass:"my-video",attrs:{"height":_vm.videoHeight,"sources":_vm.poi.pointsDetail.video_dir,"poster":_vm.poi.pointsDetail.thumb_img},on:{"videoEnd":function($event){return _vm.myVideoEnded()}}}):_c('swiper',{staticClass:"channel-list",attrs:{"height":"3.6rem","loop":true,"auto":true,"show-dots":false}},_vm._l((_vm.poi.imgList),function(item,index){return _c('swiper-item',{key:index,staticClass:"channel-item"},[_c('img',{staticClass:"channel-bg",attrs:{"src":_vm.GLOBAL.DOMAIN_URL + item.midImg,"alt":""}}),_vm._v(" "),(
              _vm.poi.pointsDetail.video_dir != null &&
                _vm.commonFun.trim(_vm.poi.pointsDetail.video_dir) != ''
            )?_c('div',{staticClass:"play-video-btn",on:{"click":function($event){return _vm.playVideo()}}}):_vm._e()])}),1)],1):_c('div',[(_vm.isShowVideo)?_c('myVideo',{ref:"myVideo",staticClass:"my-video",attrs:{"height":_vm.videoHeight,"sources":_vm.poi.pointsDetail.video_dir,"poster":_vm.poi.pointsDetail.thumb_img},on:{"videoEnd":function($event){return _vm.myVideoEnded()}}}):_c('swiper',{staticClass:"channel-list",attrs:{"height":"3.6rem","loop":true,"auto":true,"show-dots":false}},[_c('div',{staticClass:"channel-item"},[_c('img',{staticClass:"channel-bg",attrs:{"src":_vm.poi.pointsDetail.thumb_img,"alt":""}}),_vm._v(" "),(
              _vm.poi.pointsDetail.video_dir != null &&
                _vm.commonFun.trim(_vm.poi.pointsDetail.video_dir) != ''
            )?_c('div',{staticClass:"play-video-btn",on:{"click":function($event){return _vm.playVideo()}}}):_vm._e()])])],1)]),_vm._v(" "),(_vm.audioSrc)?_c('myAudio',{attrs:{"audioSrc":_vm.audioSrc,"height":"1.06rem"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"poi-name"},[_vm._v(_vm._s(_vm.poi.pointsDetail.name))]),_vm._v(" "),_c('div',{staticClass:"poi-des",domProps:{"innerHTML":_vm._s(_vm.poi.pointsDetail.description)}},[_vm._v("\n    "+_vm._s(_vm.poi.pointsDetail.description)+"\n  ")])],1):_vm._e()}
var poi_staticRenderFns = []
var poi_esExports = { render: poi_render, staticRenderFns: poi_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_poi = (poi_esExports);
// CONCATENATED MODULE: ./src/pages/poi.vue
function poi_injectStyle (ssrContext) {
  __webpack_require__("6XlR")
  __webpack_require__("S0J1")
}
var poi_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var poi___vue_template_functional__ = false
/* styles */
var poi___vue_styles__ = poi_injectStyle
/* scopeId */
var poi___vue_scopeId__ = "data-v-06aad74c"
/* moduleIdentifier (server only) */
var poi___vue_module_identifier__ = null
var poi_Component = poi_normalizeComponent(
  pages_poi,
  selectortype_template_index_0_src_pages_poi,
  poi___vue_template_functional__,
  poi___vue_styles__,
  poi___vue_scopeId__,
  poi___vue_module_identifier__
)

/* harmony default export */ var src_pages_poi = (poi_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js



 //主页
 //展馆主页
 //展馆主页


vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
var router_router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    redirect: {
      path: '/index'
    }
  }, {
    path: '/index',
    name: 'index',
    component: src_pages,
    meta: {
      // 页面标题title
      title: '百馆百址'
    }
  }, {
    path: '/museum',
    name: 'museum',
    component: src_pages_museum,
    meta: {
      // 页面标题title
    }
  }, {
    path: '/poi',
    name: 'poi',
    component: src_pages_poi,
    meta: {
      // 页面标题title
    }
  }]
});

router_router.beforeEach(function (to, from, next) {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
/* harmony default export */ var src_router = (router_router);
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js + 1 modules
var wechat = __webpack_require__("n6Wb");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// EXTERNAL MODULE: ./node_modules/sha1/sha1.js
var sha1 = __webpack_require__("uXeI");
var sha1_default = /*#__PURE__*/__webpack_require__.n(sha1);

// CONCATENATED MODULE: ./src/assets/utils/wx.js






vue_esm["a" /* default */].use(wechat["a" /* default */]);
vue_esm["a" /* default */].use(ajax["a" /* default */]);

/* harmony default export */ var wx = ({

  wxShare: function wxShare(obj, callback) {
    console.log(obj, callback);
    if (obj) {
      var title = obj.title == undefined || obj.title == null ? "测试系统" : obj.title;
      var link = obj.link == undefined || obj.link == null ? window.location.href : obj.link;
      var desc = obj.desc == undefined || obj.desc == null ? "测试系统" : obj.desc;
      var imgUrl = obj.imgUrl == undefined || obj.imgUrl == null ? "src/img/share.png" : obj.imgUrl;
    } else {
      alert("请传分享参数");
    }

    vue_esm["a" /* default */].wechat.onMenuShareTimeline({
      title: title, // 分享标题
      link: link, // 分享链接
      desc: desc, // 分享描述
      imgUrl: imgUrl, // 分享图标
      success: function success() {
        callback && callback();
      },
      cancel: function cancel() {}
    });

    vue_esm["a" /* default */].wechat.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      type: "", // 分享类型,music、video或link，不填默认为link
      dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
      success: function success() {

        callback && callback();
      },
      cancel: function cancel() {}
    });

    vue_esm["a" /* default */].wechat.onMenuShareQQ({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function success() {

        callback && callback();
      },
      cancel: function cancel() {}
    });

    vue_esm["a" /* default */].wechat.onMenuShareQZone({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function success() {

        callback && callback();
      },
      cancel: function cancel() {}
    });

    vue_esm["a" /* default */].wechat.onMenuShareWeibo({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function success() {

        callback && callback();
      },
      cancel: function cancel() {}
    });
  },
  wxConfig: function wxConfig(isDebug, shareObj, callback) {
    function getUrl() {
      var url = window.location.href;

      var locationurl = url.split("#")[0];

      console.log(locationurl);

      return locationurl;
    }
    console.log(isDebug);

    vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.GLOBAL.BASE_URL + "/api/v1/getTokenAndTicket?appid=wx826bc7a2f2c367ac").then(function (response) {
      return response.data.data;
    }).then(function (data) {

      var ret = {
        appId: "wx826bc7a2f2c367ac",
        timestamp: parseInt(new Date().getTime() / 1000),
        nonceStr: Math.random().toString(36).substr(2),
        jsapi_ticket: data.ticket,
        signature: "",
        url: getUrl()
      };
      var string = "jsapi_ticket=" + ret.jsapi_ticket + "&noncestr=" + ret.nonceStr + "&timestamp=" + ret.timestamp + "&url=" + ret.url;
      ret.signature = sha1_default()(string);

      var wxdata = {
        debug: isDebug,
        appId: ret.appId,
        timestamp: ret.timestamp,
        nonceStr: ret.nonceStr,
        jsapi_ticket: ret.jsapi_ticket,
        signature: ret.signature,
        url: ret.url,
        jsApiList: ["getLocation", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "downloadVoice", "chooseImage", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getNetworkType", "openLocation", "getLocation", "hideOptionMenu", "showOptionMenu", "hideMenuItems", "showMenuItems", "hideAllNonBaseMenuItem", "showAllNonBaseMenuItem", "closeWindow", "scanQRCode", "chooseWXPay", "openProductSpecificView", "addCard", "chooseCard", "openCard"]
      };

      console.log(wxdata);

      vue_esm["a" /* default */].wechat.config(wxdata);
      vue_esm["a" /* default */].wechat.ready(function () {

        vue_esm["a" /* default */].wechat.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            console.log("在小程序里");
            sessionStorage.setItem("isSP", "true");
          } else {
            sessionStorage.setItem("isSP", "false");
            console.log("不在小程序里");
          }
        });
        vue_esm["a" /* default */].wechat.onMenuShareTimeline({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          success: function success() {
            callback && callback();
          },
          cancel: function cancel() {}
        });

        vue_esm["a" /* default */].wechat.onMenuShareAppMessage({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          type: "", // 分享类型,music、video或link，不填默认为link
          dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
          success: function success() {

            callback && callback();
          },
          cancel: function cancel() {}
        });

        vue_esm["a" /* default */].wechat.onMenuShareQQ({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          success: function success() {

            callback && callback();
          },
          cancel: function cancel() {}
        });

        vue_esm["a" /* default */].wechat.onMenuShareQZone({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          success: function success() {

            callback && callback();
          },
          cancel: function cancel() {}
        });

        vue_esm["a" /* default */].wechat.onMenuShareWeibo({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl, // 分享图标
          success: function success() {

            callback && callback();
          },
          cancel: function cancel() {}
        });
        vue_esm["a" /* default */].wechat.getLocation({
          type: "gcj02", // 默认为 wgs84 返回 gps 坐标，gcj02 返回可用于 wx.openLocation 的坐标
          success: function success(res) {

            console.log("获取微信定位成功！");

            localStorage.setItem("lat", res.latitude);
            localStorage.setItem("lng", res.longitude);
          }
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: "app",
  created: function created() {
    var that = this;
    if (this.GLOBAL.isWx) {
      // 微信jssdk 配置
      wx.wxConfig(false, {
        title: "百馆百址", // 分享标题
        link: window.location.href, // 分享链接
        desc: window.location.href, // 分享描述
        imgUrl: "" // 分享图标
      }, function () {
        //分享成功后的回调函数
        console.log("分享成功");
      });
    } else {
      var geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
      // 单次定位 获取定位成功事件
      var showPosition = function showPosition(position) {
        console.log("定位成功");
        console.log(position);
        localStorage.setItem("lng", position.lng);
        localStorage.setItem("lat", position.lat);
      };
      // 单次定位 获取定位失败事件
      var showErr = function showErr() {
        console.log("首次定位失败");
        that.$vux.toast.text("获取定位失败", "bottom");
      };
      geolocation.getLocation(showPosition, showErr, { timeout: 8000 });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: "app",
  created: function created() {
    var that = this;
    if (this.GLOBAL.isWx) {
      // 微信jssdk 配置
      wx.wxConfig(false, {
        title: "百馆百址", // 分享标题
        link: window.location.href, // 分享链接
        desc: window.location.href, // 分享描述
        imgUrl: "" // 分享图标
      }, function () {
        //分享成功后的回调函数
        console.log("分享成功");
      });
    } else {
      var geolocation = new qq.maps.Geolocation("3HQBZ-TEX3X-NJF43-73EDL-RUD7H-NVBJM", "myweb");
      // 单次定位 获取定位成功事件
      var showPosition = function showPosition(position) {
        console.log("定位成功");
        console.log(position);
        localStorage.setItem("lng", position.lng);
        localStorage.setItem("lat", position.lat);
      };
      // 单次定位 获取定位失败事件
      var showErr = function showErr() {
        console.log("首次定位失败");
        that.$vux.toast.text("获取定位失败", "bottom");
      };
      geolocation.getLocation(showPosition, showErr, { timeout: 8000 });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea7394ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("zbel")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// CONCATENATED MODULE: ./src/assets/utils/commonFun.js


/* harmony default export */ var commonFun = ({

  getGreatCircleDistance: function getGreatCircleDistance(lat1, lng1, lat2, lng2) {
    var EARTH_RADIUS = 6378137.0;
    var PI = Math.PI;

    function getRad(d) {
      return d * PI / 180.0;
    }
    var radLat1 = getRad(lat1);
    var radLat2 = getRad(lat2);

    var a = radLat1 - radLat2;
    var b = getRad(lng1) - getRad(lng2);

    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000.0;

    return s;
  },

  openLocation: function openLocation(name, lat1, lng1, lat2, lng2) {
    console.log(vue_esm["a" /* default */].prototype.GLOBAL.isWx);
    if (vue_esm["a" /* default */].prototype.GLOBAL.isWx) {
      vue_esm["a" /* default */].prototype.$wechat.openLocation({
        latitude: Number(lat2), // 纬度，范围为-90~90，负数表示南纬
        longitude: Number(lng2), // 经度，范围为-180~180，负数表示西经
        scale: 28, // 缩放比例
        name: name, // 位置名

        success: function success(res) {},
        fail: function fail() {},
        complete: function complete() {}
      });
    } else if (vue_esm["a" /* default */].prototype.GLOBAL.bIsDtDreamApp) {
      console.log('导航');
      ZWJSBridge.openLink({
        url: 'zwfw://openThirdMap?longitude=' + lng2 + '&latitude=' + lat2 + '&locationName=' + name
      }).then(function (result) {
        console.log(result);
      }).catch(function (error) {
        console.log(error);
      });
    } else if (vue_esm["a" /* default */].prototype.GLOBAL.bIsAlipayMini) {
      my.openLocation({
        longitude: lng2,
        latitude: lat2,
        name: name,
        address: name
      });
    } else {

      var url = "http://uri.amap.com/navigation//uri.amap.com/navigation?from=" + lng1 + "," + lat1 + ",我的位置&to=" + lng2 + "," + lat2 + "," + name + "&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0";
      window.location.href = url;
    }
  },
  getCookie: function getCookie(c_name) {
    if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        var c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  },
  delCookie: function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null) {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },
  setCookie: function setCookie(name, value, time) {
    if (arguments.length == 2) {
      var Days = 7;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie = name + "=" + escape(value) + "; expires=" + exp.toGMTString();
    } else {
      var strsec = getsec(time);
      var _exp = new Date();
      _exp.setTime(_exp.getTime() + strsec * 1);
      document.cookie = name + "=" + escape(value) + ";expires=" + _exp.toGMTString();
    }
  },
  getsec: function getsec(str) {
    var str1 = str.substring(1, str.length) * 1;
    var str2 = str.substring(0, 1);
    if (str2 == "s") {
      return str1 * 1000;
    } else {
      if (str2 == "h") {
        return str1 * 60 * 60 * 1000;
      } else {
        if (str2 == "d") {
          return str1 * 24 * 60 * 60 * 1000;
        }
      }
    }
  },
  GetQueryString: function GetQueryString(name) {
    var url = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var newUrl = window.location.search.substr(1).match(url);
    if (newUrl != null) {
      return unescape(newUrl[2]);
    } else {
      return false;
    }
  },
  getUrlCode: function getUrlCode() {
    // 截取url中的code方法
    var url = location.search;
    this.winUrl = url;
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      var strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
      }
    }
    return theRequest;
  },

  /**
  * 音频播放时间换算
  * @param {number} value - 音频当前播放时间，单位秒
  */
  transTime: function transTime(value) {
    var time = "";
    var h = parseInt(value / 3600);
    value %= 3600;
    var m = parseInt(value / 60);
    var s = parseInt(value % 60);
    if (h > 0) {
      time = this.formatTime(h + ":" + m + ":" + s);
    } else {
      time = this.formatTime(m + ":" + s);
    }

    return time;
  },


  /**
  * 格式化时间显示，补零对齐
  * eg：2:4  -->  02:04
  * @param {string} value - 形如 h:m:s 的字符串
  */
  formatTime: function formatTime(value) {
    var time = "";
    var s = value.split(':');
    var i = 0;
    for (; i < s.length - 1; i++) {
      time += s[i].length == 1 ? "0" + s[i] : s[i];
      time += ":";
    }
    time += s[i].length == 1 ? "0" + s[i] : s[i];

    return time;
  },
  trim: function trim(string) {
    return string.replace(/(^\s*)|(\s*$)/g, '');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global.vue

var BASE_URL = void 0;
//打包环境判断
if (true) {
  // console.log('正式环境')
  // BASE_URL = "https://dy.worldmaipu.com";
  BASE_URL = "https://yty.tourzj.com";
} else {
  // console.log('测试环境')
  //不用跨域
  // Vue.prototype.GLOBAL.BASE_URL = "http://192.168.1.8:8081"
  //跨域，proxyTable代理，自定义如/api
  BASE_URL = "/api";
}
// const DOMAIN_URL = "https://dy.worldmaipu.com/"; //资源域名地址
var DOMAIN_URL = "https://big-file.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/"; //资源域名地址

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
var isWx = u.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
var isPc = !/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
var sUserAgent = window.navigator.userAgent.toLowerCase();
var bIsDtDreamApp = sUserAgent.indexOf("dtdreamweb") > -1; // 浙里办APP
var bIsAlipayMini = sUserAgent.indexOf("miniprogram") > -1 && sUserAgent.indexOf("alipay") > -1;
/* harmony default export */ var global = ({
  BASE_URL: BASE_URL, //接口地址
  DOMAIN_URL: DOMAIN_URL, //静态文件域名
  isAndroid: isAndroid, //是否在安卓
  isIos: isIos, //是否在ios
  isWx: isWx, //是否在微信
  isPc: isPc, //是否在pc
  bIsDtDreamApp: bIsDtDreamApp,
  bIsAlipayMini: bIsAlipayMini
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global.vue

var global_BASE_URL = void 0;
//打包环境判断
if (true) {
  // console.log('正式环境')
  // BASE_URL = "https://dy.worldmaipu.com";
  global_BASE_URL = "https://yty.tourzj.com";
} else {
  // console.log('测试环境')
  //不用跨域
  // Vue.prototype.GLOBAL.BASE_URL = "http://192.168.1.8:8081"
  //跨域，proxyTable代理，自定义如/api
  global_BASE_URL = "/api";
}
// const DOMAIN_URL = "https://dy.worldmaipu.com/"; //资源域名地址
var global_DOMAIN_URL = "https://big-file.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/"; //资源域名地址

var global_u = navigator.userAgent;
var global_isAndroid = global_u.indexOf("Android") > -1 || global_u.indexOf("Adr") > -1; //android终端
var global_isIos = !!global_u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
var global_isWx = global_u.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
var global_isPc = !/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
var global_sUserAgent = window.navigator.userAgent.toLowerCase();
var global_bIsDtDreamApp = global_sUserAgent.indexOf("dtdreamweb") > -1; // 浙里办APP
var global_bIsAlipayMini = global_sUserAgent.indexOf("miniprogram") > -1 && global_sUserAgent.indexOf("alipay") > -1;
/* harmony default export */ var components_global = ({
  BASE_URL: global_BASE_URL, //接口地址
  DOMAIN_URL: global_DOMAIN_URL, //静态文件域名
  isAndroid: global_isAndroid, //是否在安卓
  isIos: global_isIos, //是否在ios
  isWx: global_isWx, //是否在微信
  isPc: global_isPc, //是否在pc
  bIsDtDreamApp: global_bIsDtDreamApp,
  bIsAlipayMini: global_bIsAlipayMini
});
// CONCATENATED MODULE: ./src/components/global.vue
var global_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var global___vue_template_functional__ = false
/* styles */
var global___vue_styles__ = null
/* scopeId */
var global___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var global___vue_module_identifier__ = null
var global_Component = global_normalizeComponent(
  components_global,
  __vue_template__,
  global___vue_template_functional__,
  global___vue_styles__,
  global___vue_scopeId__,
  global___vue_module_identifier__
)

/* harmony default export */ var src_components_global = (global_Component.exports);

// CONCATENATED MODULE: ./src/main.js














vue_esm["a" /* default */].prototype.commonFun = commonFun;
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);

vue_esm["a" /* default */].use(ajax["a" /* default */]);
vue_esm["a" /* default */].use(src_router);

vue_esm["a" /* default */].use(vue_video_player_default.a);
__webpack_require__("RIv7");

/**
* 定义常量
*/



vue_esm["a" /* default */].prototype.GLOBAL = src_components_global;
console.log(vue_esm["a" /* default */].prototype.GLOBAL);

var loginTimeOutErrorCode = 'login_timeout_error';
if (src_components_global.bIsDtDreamApp || src_components_global.bIsAlipayMini) {
  console.log('浙里办或者支付宝!!');
  ZWJSBridge.onReady(function () {
    console.log('ZWJSBridge_onReady!!');

    ZWJSBridge.getUiStyle({}).then(function (result) {
      switch (result.uiStyle) {
        case 'normal':
          sessionStorage.setItem('usertype', 'normal');
          break;
        case 'elder':

          var HtmlContainer = window.document.querySelector('html');
          HtmlContainer.setAttribute('style', 'font-size:70px !important');
          sessionStorage.setItem('usertype', 'elder');
          break;
        default:
          sessionStorage.setItem('usertype', 'normal');
      }
      console.log(result, '用户模式');
    }).catch(function (error) {
      sessionStorage.setItem('usertype', 'normal');
      console.log(error);
    });
  });
}

var HtmlContainer = window.document.querySelector('html');
HtmlContainer.setAttribute('style', 'font-size:70px !important');

/**
* 定义全局公用常量
*/

/**
* 定义全局公用方法
*/
vue_esm["a" /* default */].prototype.http = function (opts) {
  var vue = this;
  if (opts.isShowLoading) {
    vue.$vux.loading.show({
      text: '加载中...'
    });
  }

  vue.$http({
    method: opts.method,
    url: opts.url,
    headers: opts.headers || {},
    params: opts.params || {},
    data: opts.data || {}
  }).then(function (response) {
    vue.$vux.loading.hide();

    opts.success(response);
  }).catch(function (error) {
    vue.$vux.loading.hide();
    console.log(error);
    if (!opts.error) {
      console.log(!opts.error);
      var response = error.response;
      var errorMessage = response.statusText;
      console.log(response);
      console.log(errorMessage);

      vue.$vux.alert.show({
        title: '提示',
        content: errorMessage

      });
    } else {
      console.log(opts.error(error.response.data.data));
      opts.error(error.response.data.data);
    }
  });
};

vue_esm["a" /* default */].prototype.get = function (opts) {
  opts.method = 'get';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.post = function (opts) {
  opts.method = 'post';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.put = function (opts) {
  opts.method = 'put';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.delete = function (opts) {
  opts.method = 'delete';
  this.http(opts);
};

vue_esm["a" /* default */].prototype.valid = function (opts) {
  var vue = this;
  var valid = true;

  if (opts.ref && !opts.ref.valid) {
    valid = false;
  }

  if (opts.ignoreRefs) {
    var newRefs = [];
    for (var i in opts.refs) {
      var ref = opts.refs[i];
      for (var j in opts.ignoreRefs) {
        var ignoreRef = opts.ignoreRefs[j];
        if (ref !== ignoreRef) {
          newRefs.push(ref);
        }
      }
    }
    opts.refs = newRefs;
  }

  for (var _i in opts.refs) {
    if (!opts.refs[_i].valid) {
      valid = false;
      break;
    }
  }

  if (valid) {
    opts.success();
  } else if (opts.error) {
    opts.error();
  } else {
    vue.$vux.toast.show({
      text: '请检查输入'
    });
  }
};

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "QoHd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RIv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S0J1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WBQF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y4Lg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZdaW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d4Xq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g3Gj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gWrV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js + 1 modules
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZdaW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var alert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var alert_staticRenderFns = []
var alert_esExports = { render: alert_render, staticRenderFns: alert_staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (alert_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function alert_injectStyle (ssrContext) {
  __webpack_require__("qJoR")
}
var alert_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var alert___vue_template_functional__ = false
/* styles */
var alert___vue_styles__ = alert_injectStyle
/* scopeId */
var alert___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var alert___vue_module_identifier__ = null
var alert_Component = alert_normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  alert___vue_template_functional__,
  alert___vue_styles__,
  alert___vue_scopeId__,
  alert___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (alert_Component.exports);


/***/ }),

/***/ "qJoR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("ruXm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ruXm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zbel":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6f0cfba9424f0f4297e7.js